import { __extends } from "tslib";
import React from 'react';
import ReactPlayer from 'react-player/lazy';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEqual from 'lodash/isEqual';
import { mergeStyles, validate } from 'wix-rich-content-common';
import schema from './data-schema.json';
import styles from './styles/video-viewer.scss';
var VideoViewer = /** @class */ (function (_super) {
    __extends(VideoViewer, _super);
    function VideoViewer(props) {
        var _this = _super.call(this, props) || this;
        validate(props.componentData, schema);
        _this.styles = mergeStyles({
            styles: styles,
            theme: props.theme || {},
        });
        return _this;
    }
    VideoViewer.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (!isEqual(nextProps.componentData, this.props.componentData)) {
            validate(nextProps.componentData, schema);
        }
    };
    VideoViewer.prototype.render = function () {
        // Omitting children here since passing children to ReactPlayer causes it to call
        // its own version of isEqual infinitely, triggering a "Max call stack exceeded error"
        var src = this.props.componentData.src;
        if (!ReactPlayer.canPlay(src)) {
            return null;
        }
        return (React.createElement(ReactPlayer, { controls: true, config: { youtube: { playerVars: { fs: 0 } } }, className: classNames(this.styles.video_player), url: src, width: '100%', height: '100%' }));
    };
    VideoViewer.propTypes = {
        componentData: PropTypes.object.isRequired,
        theme: PropTypes.object,
        onReady: PropTypes.func,
        onStart: PropTypes.func,
        controls: PropTypes.bool,
        width: PropTypes.string,
        height: PropTypes.string,
    };
    VideoViewer.defaultProps = {
        width: '100%',
        height: '100%',
        controls: true,
    };
    return VideoViewer;
}(React.Component));
export default VideoViewer;
//# sourceMappingURL=video-viewer.js.map